import * as angular from "angular";
import {ITimeoutService, IWindowService} from "angular";

export class ResizeService {
  defaultTime: number = 100

  constructor(private $timeout: ITimeoutService, private $window: IWindowService) {
  }

  resize(time?) {
    this.$timeout(time || this.defaultTime)
      .then(() => {
        this.$window.dispatchEvent(new Event('resize'));
      })
  }
}

angular
  .module('bringoz.admin.commons')
  .service('resizeService', ResizeService);
